import React from "react";

import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/ThirdpartyDataHubStyle";

import EADialog from "components/common/EADialog";
import DataHubBlock from "./DataHubBlock";
import { Typography } from "@mui/material";
import i18next from "i18next";

const DataHubDetailDialog = ({
  isOpen,
  dataHubData,
  sourceName,
  onClose,
}) => {
  const { classes } = useStyles();

  return (
    <EADialog
      isOpen={isOpen}
      onCancel={onClose}
      hasActions={false}
      title={i18next.t("thirdpartySheet.dataHub.completeReport", { sourceName: sourceName })}
      maxWidth={"popupxl"}
      fullWidth
      crossVisible={true}
      style={{overflow: "hidden"}}
    >
      {dataHubData && (
        <>
        <Typography className={classes.popupSubTtitle}>{i18next.t("thirdpartySheet.dataHub.detailedData")}</Typography>
          <div className={classes.greyBackground}>
            {dataHubData?.map((item, index) => {
                      return (
                        <DataHubBlock label={item?.label} value={item?.value} key={index} />
                      )
                    })}
          </div>
        </>
      )}
    </EADialog>
  );
}

export default DataHubDetailDialog;
